export default {
  revokeToken: 'Revoke token',
  revokeSelectedTokens: 'Revoke selected tokens',
  tokenExpiration: 'Token expiration',
};
